import React, { Component } from 'react';
import { Route, withRouter, Switch, Redirect } from 'react-router-dom';
import { connect } from 'react-redux'
import Header from './components/Header';
import Sidebar from './components/Sidebar';
import Loader from './components/Loader';
import MessageBar from './components/MessageBar';
import messageActions from './actions/message';
import adminActions from './actions/admin';
import tokenHelpers from './helpers/token';
import Contact from './containers/Contact';
import UpdateUser from './containers/UpdateUser';
import ForgotPassword from './containers/ForgotPassword';
import ResetPassword from './containers/ResetPassword';
import VerifyEmail from './containers/VerifyEmail';

import Home from './containers/Home';
import Companies from './containers/Companies';
import Locations from './containers/Locations';
import OneTimeText from './containers/OneTimeText';
import AutoCampaigns from './containers/AutoCampaigns';
import BusinessIntelligence from './containers/BusinessIntelligence';
import Members from './containers/Members';
import Plans from './containers/Plans';
import SignUp from './containers/SignUp';
import SignIn from './containers/SignIn';
import Surveys from './containers/Surveys';
import Users from './containers/Users';
import Cashiers from './containers/Cashiers';
import Help from './containers/Help';
import TermsOfService from './containers/TermsOfService';
import PrivacyPolicy from './containers/PrivacyPolicy';
import './App.css';


class App extends Component {
  constructor() {
    super();
    this.handleMessageClick = this.handleMessageClick.bind(this);
    this.locationHasChanged = this.locationHasChanged.bind(this);
    this.handleLogout = this.handleLogout.bind(this);
  }

  componentWillMount() {
    let token = tokenHelpers.getToken();
    this.setState({ token })
    const { admin, location, dispatch } = this.props;
    if (!admin.data && token) {
      dispatch(adminActions.retrieve(token, location.pathname));
    }
  }

  componentWillReceiveProps(nextProps) {
    let token = tokenHelpers.getToken();
    let { admin, location, dispatch } = this.props;

    if (!this.props.admin.data && token && !this.state.token) {
      this.setState({ token: nextProps.admin.data.apikey });
      dispatch(adminActions.retrieve(token, location.pathname));
    }
  }

  locationHasChanged() {
    this.props.dispatch(messageActions.clearMessages());
  }

  handleMessageClick() {
    this.props.dispatch(messageActions.clearMessages());
  }

  handleLogout() {
    this.setState({ token: null })
    this.props.dispatch(adminActions.logout());
  }

  render() {
    if (this.state.token ) {
      return (
        <div className={this.props.modal.showModal ? 'wrap wrap--fixed' : 'wrap'}>
  				<Sidebar path={this.props.location.pathname}/>
  				<div className="content">
  					<MessageBar
  						onClick={this.handleMessageClick}
  						messageType="error"
  						message={this.props.message.errorMessage}/>
  					<MessageBar
  						onClick={this.handleMessageClick}
  						messageType="success"
  						message={this.props.message.successMessage}/>
            <Route exact path="/" render={routeProps => <Home {...routeProps} handleLogoutClick={this.handleLogout} /> } />
            <Route path="/update-user" render={routeProps => <UpdateUser {...routeProps} handleLogoutClick={this.handleLogout} /> } />
            <Route path="/companies" render={routeProps => <Companies {...routeProps} handleLogoutClick={this.handleLogout} /> } />
            <Route path="/locations" render={routeProps => <Locations {...routeProps} handleLogoutClick={this.handleLogout} /> } />
            <Route path="/one-time-text" render={routeProps => <OneTimeText {...routeProps} handleLogoutClick={this.handleLogout} /> } />
            <Route path="/auto-campaigns" render={routeProps => <AutoCampaigns {...routeProps} handleLogoutClick={this.handleLogout} /> } />
            <Route path="/business-intelligence" render={routeProps => <BusinessIntelligence {...routeProps} handleLogoutClick={this.handleLogout} /> } />
            <Route path="/members" render={routeProps => <Members {...routeProps} handleLogoutClick={this.handleLogout} /> } />
            <Route path="/plans" render={routeProps => <Plans {...routeProps} handleLogoutClick={this.handleLogout} /> } />
            <Route path="/surveys" render={routeProps => <Surveys {...routeProps} handleLogoutClick={this.handleLogout} /> } />
            <Route path="/users" render={routeProps => <Users {...routeProps} handleLogoutClick={this.handleLogout} /> } />
            <Route path="/cashiers" render={routeProps => <Cashiers {...routeProps} handleLogoutClick={this.handleLogout} /> } />
            <Route path="/help" render={routeProps => <Help {...routeProps} handleLogoutClick={this.handleLogout} /> } />
            <Route path="/terms-of-service" render={routeProps => <TermsOfService {...routeProps} handleLogoutClick={this.handleLogout} /> } />
            <Route path="/privacy-policy" render={routeProps => <PrivacyPolicy {...routeProps} handleLogoutClick={this.handleLogout} /> } />
  				</div>
          {
            this.props.loading.isLoading &&
            <Loader />
          }
        </div>
      );
    } else {
      return <div>
          <MessageBar onClick={this.handleMessageClick} messageType="error" message={this.props.message.errorMessage} />
          <MessageBar onClick={this.handleMessageClick} messageType="success" message={this.props.message.successMessage} />
          <Switch>
            <Route exact path="/" component={SignIn} />
            <Route path="/sign-up" component={SignUp} />
            <Route path="/sign-in" component={SignIn} />
            <Route path="/forgot-password" render={routeProps => <ForgotPassword />} />
            <Route path="/password-reset" render={routeProps => <ResetPassword {...routeProps} />} />
            <Redirect to="/" />
          </Switch>
        </div>;
    }
  }
}

export default withRouter(connect(
  (state) => ({
    message: state.message,
    loading: state.loading,
    admin: state.admin,
    modal: state.modal
  })
)(App));



/** WEBPACK FOOTER **
 ** ./src/App.js
 **/